/**
 * MyRequests Page
 *
 * Page wrapper for My Requests List.
 *
 * @module pages/feedback/MyRequests
 */

import React from 'react';
import { Box, Container } from '@mui/material';
import MyRequestsList from '../../components/feedback/MyRequestsList';

/**
 * MyRequests Page
 */
const MyRequests: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box py={4}>
        <MyRequestsList />
      </Box>
    </Container>
  );
};

export default MyRequests;
